
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["help",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 1C11.317 1 1 11.318 1 24s10.317 23 23 23 23-10.318 23-23S36.683 1 24 1zm-1.5 35a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm8.111-15.997c-.645 1.717-2.025 2.841-3.56 4.038-2.45 1.923-2.525 2.585-2.525 4.531h-3.172c0-1.016-.068-2.448.647-3.754.431-.787 1.187-1.602 2.266-2.444 2.143-1.692 3.042-2.569 3.042-4.369 0-2.005-1.497-2.816-3.512-2.816-1.319 0-2.792.2-5.405 1.489l-1.359-2.848a14.242 14.242 0 017.04-1.83c2.114 0 3.792.518 5.033 1.554 1.24 1.036 1.861 2.465 1.861 4.289 0 .808-.119 1.528-.356 2.16z"}})])
          )
        }
      }
    